@import 'styles/mixins';
@import 'styles/variables';

.header {
  @include xl-semibold;

  align-items: center;
  border-bottom: 1px solid var(--neutral-10);
  color: var(--neutral-90);
  display: flex;
  justify-content: space-between;
  height: 66px;
  padding: 16px 16px 8px;
}

.backIcon {
  margin-right: 4px;
  height: 36px;
  width: 36px;

  svg {
    path {
      fill: var(--neutral-40);
    }
  }
}

.body {
  padding: 20px 24px 24px 24px;
}

.footer {
  @include md-regular;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 24px 16px 24px;
  justify-content: right;
}

.recipients {
  align-items: center;
}

.label {
  @include lg-medium;
  color: var(--neutral-90);
}

.messageFieldLabel {
  padding-bottom: 10px;
  margin-top: 36px;
}

.explanationLabel {
  margin-top: 36px;
}

.secondaryLabel {
  @include sm-regular;
  height: 16px;
  margin-top: 12px;
  margin-bottom: 4px;
  color: var(--neutral-40);
}

.reviewersFieldsWrapper {
  position: relative;
}

.menuTrigger {
  margin: 0 0 2px -8px;
}

.itemsContainer {
  min-width: 140px;
}

.radioButtonsContainer {
  margin: 36px 0;
  gap: 8px;
  display: flex;
  flex-direction: column;

  .selected {
    background: none;
  }
}

.templateDisplayText {
  display: flex;
  gap: 8px;
  align-items: center;
}

.templatesContainer {
  max-height: 356px;

  svg path {
    fill: var(--neutral-40);
  }
}
